import { StatusCodes } from 'http-status-codes'

export const getResponseErrorMessage = (error) => {
  if (error.response) {
    return error.response.data.message
  }

  return error.message
}

export const getResponseErrorStatus = (error) => {
  if (error.response) {
    return error.response.status
  }

  return error.statusCode || StatusCodes.INTERNAL_SERVER_ERROR
}

export const isInvalidCheckoutCartError = (error) => {
  if (!error.response || ![400, 422].includes(error.response.status)) {
    return false
  }

  const response = error.response.data || {}
  return JSON.stringify([
    response.message,
    response.errors,
    response.data
  ]).includes('cart_ids')
}

export const isResponseInternalServerError = (error) => {
  if (!error.response) {
    return true
  }

  return error.response && error.response.status >= 500 && error.response.status < 600
}
